import React from "react";
import { Nav, Navbar, Button, Container } from "react-bootstrap";
import Css from './Layout.module.css';
import { NavLink, useNavigate } from "react-router-dom";
import UtilClass from "api_ref/UtilClass";
import ApiConection from "api_ref/ApiConection";
import { useState } from "react";
import { useEffect } from "react";

export default function ModulePageHeadMenu() {
    const [atsUrl, setAtsUrl] = useState();

    const api = new ApiConection();

    const util = new UtilClass();

    const navigate = useNavigate();

    const getATSUrl = async () => {
        const response = await api.callLandingPageGet(`api/ConfigApp/54`);
        if (response.status === true) {
            setAtsUrl(response.data.value);
        } else {
            setAtsUrl(process.env.REACT_APP_ATS_POTAL);
        }
    }
    const handleATSPotral = (event) => {
        window.open(atsUrl, '_blank');
    }

    const handleModule = (event) => {
        navigate('/module');
    }

    const handleLogin = (event) => {
        navigate('/login');
    }
    const handleFreeRegister = (event) => {
        //---- save period = 1 = month , package free id = 1;
        util.setCookie('period_id', 1, 1);
        util.setCookie('package_id', 1, 1);
        navigate('/register');
    }

    useEffect(() => {
        getATSUrl();
    }, []);

    return (
        <div className={`${Css.Menu} ${Css.Fixed}  ${Css.Menu_Mobile}`}>
            <Navbar expand="lg">
                <Container fluid className={Css.Container_Fluid}>
                    <Navbar.Brand >
                        <img src={require('../../images/DCasS.png')} className={Css.img_nav_mobile} alt={''} height={'38px'} />
                    </Navbar.Brand>
                    <Nav className={Css.Nav_Mobile}>
                        <Button type="button" className={`btn-primary-trn ps-5 pe-5 ${Css.btn_round}  `} onClick={handleATSPotral}>เข้าสู่ระบบ</Button>
                    </Nav>

                    <Navbar.Toggle aria-controls="basic-navbar-nav" className={Css.NavTog} />
                    <Navbar.Collapse id="basic-navbar-nav" >
                        <Nav className={`me-auto `}>
                            <NavLink to={'/'} className={`nav-link text-center ${Css.smt}`}>หน้าหลัก</NavLink>
                            <NavLink to={'#'} className={`nav-link text-center ${Css.nolink}`}>เกี่ยวกับเรา</NavLink>
                            <NavLink to={'#'} className={`nav-link text-center  ${Css.nolink}`}>ราคาแพ็กเกจ</NavLink>
                            <NavLink to={'/manual'} className={`nav-link text-center ${Css.smt}`}>แนะนำการใช้งาน</NavLink>
                            <NavLink to={'#'} className={`nav-link text-center ${Css.nolink}`}>บทความ</NavLink>
                        </Nav>
                        <Nav className={Css.Nav_Mobile2}>
                            <Button type="button" className={`btn-primary-trn ps-5 pe-5 ${Css.btn_round}  `} onClick={handleATSPotral}>เข้าสู่ระบบ</Button>

                            {/*<Form className={'d-flex'}>
                                <Form.Select >
                                    <option>TH</option>
                                </Form.Select>
                            </Form>*/}
                        </Nav>
                    </Navbar.Collapse>
                </Container>

            </Navbar>
        </div>
    );
}